import React, { useContext, useEffect, useRef, useState } from "react";
import PlusIcon from "../icons/PlusIcon";
import PlusRound from "../icons/PlusRound";
import actions from "../actions";
import uuid from "react-uuid";
import EmptyIcon1 from "../icons/EmptyIcon1";
import EmptyIcon2 from "../icons/EmptyIcon2";
import styled, { ThemeContext } from "styled-components";
import { Dialog } from "@headlessui/react";
import WithLoader from "./WithLoader";
import appFetch from "../appFetch";
import apiEndpoints from "../apiEndpoints";
import renderComponent from "../renderComponent";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DrillModalDialog from "./DrillModalDialog";
import { appendQueryToUri } from "../util/generalUtil";
import { QuickNotificationReport } from "../constants/variables";
import icons from "../icons";

const QuickNotificationCard = styled.div`
  /* background: ${({ theme }) => theme?.colors?.accent}; */
`;

const iconMap = {
  home: "HomeIcon",
  setup: "SetupIcon",
  transaction: "TransactionIcon",
  approval: "ApprovalIcon",
  memo: "MemoIcon",
  open: "OpenIcon",
  dashboard: "DashboardIcon",
  confirmation: "ConfirmationIcon",
  payrollReports: "PayrollReportsIcon",
  otherReports: "OtherReportsIcon",
  essReports: "EssReportsIcon",
  bioData: "BioDataIcon",
  Online: "OnlineIcon",
  Users: "UsersIcon",
  Retail: "RetailIcon",
  Wallet: "WalletIcon",
  Ussd: "UssdIcon",
  Draws: "DrawsIcon",
  ThirdParty: "ThirdPartyIcon",
  Accuracy: "AccuracyIcon",
  Feeds: "FeedsIcon",
  Whatsapp: "WhatsappIcon",
  Error: "ErrorIcon",
  Calender: "CalenderIcon",
  map: "MapIcon",
  Statistics: "StatisticsIcon",
  OtherReports: "OtherReportsIcon",
  Ticket: "TicketIcon",
  Search: "SearchIcon",
  report: "OtherReportsIcon",
  Forms: "FormsIcon",
  module: "FormsIcon",
  reports: "StatisticsIcon",
  money: "MoneyIcon",
  action: "ActionIcon",
  followup: "FollowUpIcon",
  pending: "PendingIcon",
  qualified: "PassIcon",
  schedule: "ScheduledIcon",
  demo: "DemoIcon",
  proposal: "PlanIcon",
  onboarding: "OnboardIcon",
  crm: "CRMIcon",
  sales: "SalesIcon",
  inventory: "InventoryIcon",
  horizontalbarchart: "HorizontalBarIcon",
  verticalbarchart: "VerticalBarIcon",
  scatterchart: "ScatterIcon",
  layout: "LayoutIcon",
  piechart: "PieIcon",
  linechart: "LineIcon",
  bell: "BellIcon",
  User: "UserIcon",
  Browser: "InternetIcon",
  All: "AllIcon",
  Pos: "PosIcon",
  Football: "FootballIcon",
  Bingo: "BingoIcon",
  Lottery: "LotteryIcon",
  channels: "ChannelsIcon",
  "": "setup",
};


function QuickNotificationList1_2({
  setLoading,
  options,
  children,
  onClick,
  filterOption,
  accessOption,
}) {
  const theme = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [disableDrill, setDisableDrill] = useState(false);
  const gridRef = useRef(null);
  const cardLength = options?.length ?? 0;

  console.log("new options", options);

  // useEffect(() => {
  //   const el = gridRef.current
  //   console.log("gridContainer",el)
  //   el.style.setProperty('--total-grid', options.length);
  // },[options.length])

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: cardLength > 3 ? 3 : cardLength,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: cardLength > 3 ? 3 : cardLength,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: cardLength > 3 ? 3 : cardLength,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: cardLength > 1 ? 1 : cardLength,
          dots: true,
        },
      },
    ],
  };

  const showDetail = (item) => {
    setLoading(true);
    let postData = {
      layoutId: item.layoutid,
      targetId: item.targetid,
      target: item.target,
      dateFilter: filterOption,
      accessFilter: accessOption,
    };
    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, postData))
      .then((res) => {
        const { layoutid, targetid, drillid } = item;
        setModalData({
          ...res,
          layoutid,
          targetid,
          drillid,
          target: QuickNotificationReport,
        });
        setIsOpen(true);
      })
      .catch((e) => console.log(e.message))
      .finally(() => setLoading(false));
  };

  return (
    <>
      {isOpen && !disableDrill && (
        <DrillModalDialog
          isOpen={isOpen}
          closeModal={() => setIsOpen(false)}
          item={modalData}
          setLoading={setLoading}
          dateFilter={filterOption}
          accessFilter={accessOption}
        />
      )}
      <div className="mb-4">
        <Slider {...settings}>
          {" "}
          {options &&
            options?.map((item, idx) => {
              const {
                name,
                value,
                box_value,
                icon,
                box_badge_json,
                has_drill,
              } = item;

              const isDrillDisabled = has_drill === "true";

              const menuIcon = iconMap[icon] || "setup";
              return (
                <div key={idx}>
                  <QuickNotificationCard
                    onClick={() => !isDrillDisabled && showDetail(item)}
                    className="shadow-md cursor-pointer relative px-4 rounded-lg h-44 grid content-around mx-2 mb-2 border"
                  >
                    <span
                      style={{
                        backgroundColor:
                          box_badge_json && box_badge_json?.box_badge_color,
                      }}
                      className="rounded-tr-lg rounded-bl-lg w-full justify-end absolute top-0 right-0 max-w-min my-1 capitalize text-xs px-2 py-1 origin-center -translate-y-1 text-white truncate"
                      dangerouslySetInnerHTML={{
                        __html: box_badge_json?.box_badge_top_value,
                      }}
                    ></span>
                    {icons[menuIcon] ? (
                      React.createElement(icons[menuIcon], {
                        width: 24,
                        height: null,
                        fill: theme?.colors?.primary,
                        stroke: theme?.colors?.primary,
                      })
                    ) : (
                      <EmptyIcon2
                        width={26}
                        height={null}
                        fill={theme?.colors?.primary}
                      />
                    )}
                    <div className="">
                      <span
                        className={`font-semibold -pt-4 ${
                          box_value && box_value.length > 16
                            ? "text-lg"
                            : "text-xl"
                        } inline-block`}
                        dangerouslySetInnerHTML={{
                          __html: box_badge_json
                            ? box_badge_json?.box_badge_value
                            : box_value,
                        }}
                      ></span>
                      <h2 className="font-thin text-sm uppercase">{name}</h2>
                    </div>
                  </QuickNotificationCard>
                </div>
              );
            })}
        </Slider>
      </div>
    </>
  );
}

export default WithLoader(QuickNotificationList1_2);
